import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts(
  'communities',
  'removeNotificationsCounters',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'notification_counters',
  type: 'post',
  slug: ['flush'],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/removeNotificationsCounters.js